<app-life-ins-headline [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-headline>
<div class="life-ins__content">
    <div nxRow>
        <div nxCol="12,12,12,4">
            <app-life-ins-date [maInsuranceExtend]="maInsuranceExtend"></app-life-ins-date>
        </div>
        <div nxCol="12,12,12,8">
            <div nxRow *ngFor="let risk of maInsuranceExtend.risk">
                <div nxCol="6">
                    <div class="check-label">
                        <cpc-icon icon="check" [color]="'#70ad47'"></cpc-icon>
                        {{ risk.label }}
                    </div>
                </div>
                <div nxCol="6" *ngIf="risk.sumInsured && risk.sumInsured > 0">
                    <div nxRow class="pair-column">
                        <div nxCol="6">{{ 'ma-insurance.life.sumInsured' | translate }}</div>
                        <div nxCol="6">{{ risk.sumInsured|currencyFormat }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div nxRow>
        <div nxCol="12">
            <h4 nxHeadline="subsection-small" class="nx-margin-bottom-2m">
                {{ 'ma-insurance.car.insured-vehicle' | translate }}</h4>
        </div>
    </div>
    <div nxRow *ngFor="let vehicle of maInsuranceExtend.vehicle">
        <div nxCol="12,12,12,4">
            <div nxRow>
                <div nxCol="6">{{ 'ma-insurance.car.crn' | translate }}</div>
                <div nxCol="6"> {{ vehicle.crn|currencyFormat }} </div>
            </div>
        </div>
        <div nxCol="12,12,12,4">
            <div nxRow>
                <div nxCol="6">{{ 'ma-insurance.car.brand' | translate }}</div>
                <div nxCol="6"> {{ vehicle.make|currencyFormat }} </div>
            </div>
        </div>
        <div nxCol="12,12,12,4">
            <div nxRow class="pair-column">
                <div nxCol="6">{{ 'ma-insurance.car.model' | translate }}</div>
                <div nxCol="6"> {{ vehicle.type|currencyFormat }} </div>
            </div>
        </div>
    </div>
</div>